
import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import about from "@/assets/data/recruit/culture/about.json";
import benefits from "@/assets/data/recruit/culture/benefit.json";
import communication from "@/assets/data/recruit/culture/communication.json";
import infographics from "@/assets/data/recruit/culture/infographics.json";
import PageHero from "@/components/UI/renewal/PageHero.vue";
import CtaSection from "@/components/UI/renewal/CtaSection.vue";
import BrandButton from "@/components/UI/renewal/BrandButton.vue";

@Component({
  components: {PageHero, CtaSection, BrandButton}
})
export default class CultureContent extends Vue {
  private aboutText: string = about.contents.join("");
  private benefits = benefits;
  private communication = communication;
  private infographics = infographics;

  private barWidth(value: string): string {
    return `${Math.min(100, parseFloat(value))}%`;
  }

  private isNote(text: string): boolean {
    return text.startsWith("※");
  }
}
